import sendPostType from './sendPostType'

const post = ({ path, data }) => sendPostType('POST', { path, data })

export default post
